<script lang="ts">
  // At-a-glance stat tiles, shared by the site dashboard (Open issues /
  // Deals / Touchpoints / Last contact) and the owner dashboard (Sites /
  // Open issues / Deals / Touchpoints / Last contact) — same card so the two
  // read as one design language rather than two hand-copied grids. Purely
  // presentational: each page formats its own values (e.g. relative time)
  // before handing them in.
  import InsightCard from '$lib/components/ui/InsightCard.svelte';

  const {
    stats
  }: { stats: Array<{ label: string; value: string | number; hint?: string }> } = $props();

  // Tailwind needs the full class literal present in source to generate it —
  // this map (rather than a template string) is what makes that safe for
  // however many tiles a given page passes.
  const SM_COLS: Record<number, string> = {
    3: 'sm:grid-cols-3',
    4: 'sm:grid-cols-4',
    5: 'sm:grid-cols-5'
  };
  const cols = $derived(SM_COLS[stats.length] ?? 'sm:grid-cols-4');
</script>

<!-- Below `sm` a 5-up grid squeezes "Last contact" into two illegible lines,
     so the tiles become a horizontal strip you pan instead: full label, full
     value, one snap per card. From `sm` up it's the grid it has always been. -->
<div class="tym-scroll-x -mx-4 mb-5 flex gap-2.5 px-4 sm:mx-0 sm:grid sm:gap-3 sm:px-0 {cols}">
  {#each stats as s (s.label)}
    <div class="w-[45vw] max-w-[210px] shrink-0 snap-start sm:w-auto sm:max-w-none">
      <InsightCard label={s.label} value={s.value} hint={s.hint} />
    </div>
  {/each}
</div>
